'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _toHsla = require('./../conversionFunctions/toHsla');

var _toHsla2 = _interopRequireDefault(_toHsla);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (color) {
  var hsla = (0, _toHsla2.default)(color);
  return 'hsla(' + hsla.hue + ',' + hsla.saturation * 100 + '%,' + hsla.luminance * 100 + '%,' + hsla.alpha + ')';
};